import React, { useState } from "react";
import classes from "./MobileBookingLessonPage.module.css";
import { MobileConfirmBookingLessonCard } from "../../../../stories/ConfirmBookingLessonCard/MobileConfirmBookingLessonCard";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import { Radio } from "../../../../stories/Radio/Radio";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { Input } from "../../../../stories/Input/Input";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { Button } from "../../../../stories/Button/Button";
import CancellationPolicyModal from "../../../../components/Modals/Admin/CancellationPolicyModal/CancellationPolicyModal";
import RequirementsModal from "../../../../components/Modals/Admin/RequirementsModal/RequirementsModalMobile";
import BookingRequestedModal from "../../../../components/Modals/Admin/BookingRequestedModal/BookingRequestedModal";
import ErrorOccurModal from "../../../../components/Modals/Admin/ErrorOccurModal/ErrorOccurModalMobile";

import {
  CalendarIconGray,
  coachDemoImg,
  LocationIconGray,
  ClockIconGray,
  ApplePayBlack,
  EditIconGray,
  ApplePayDisabled,
  CancelIconBlack,
} from "../../../../constant/imagePath";
import { ReactSVG } from "react-svg";

import { Row, Col } from "react-bootstrap";
import { MobileFooter } from "../../../../stories/MobileFooter/MobileFooter";
import { useHistory } from "react-router";

const BookingLesson = () => {
  const history = useHistory();
  const [radioState, setRadioState] = useState("I’m booking it for myself");
  const [checkBoxState, setCheckBoxState] = useState();
  const [fullName, setFullName] = useState();
  const [dob, setDob] = useState();
  const [phoneNumber, setPhoneNumber] = useState();

  const [cardNumber, setCardNumber] = useState();
  const [cardholderName, setCardholderName] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvc, setCvc] = useState();

  const [cardNumber1, setCardNumber1] = useState();
  const [cardholderName1, setCardholderName1] = useState("");
  const [expiryDate1, setExpiryDate1] = useState("");
  const [cvc1, setCvc1] = useState();

  const [paymentDetailsState, setPaymentDetailsState] = useState(false);
  const [paymentDetailsState1, setPaymentDetailsState1] = useState(false);

  const [paymentDetailsRadioState, setPaymentDetailsRadioState] = useState(
    "Visa •••• 3679 (expires 12/24)"
  );

  const [isCancellationModalOpen, setIsCancellationModalOpen] = useState(false);
  const [isRequirementsModalOpen, setIsRequirementsModalOpen] = useState(false);
  const [isBookingRequestedModalOpen, setIsBookingRequestedModalOpen] =
    useState(false);
  const [isErrorOccurenceModalOpen, setIsErrorOccurenceModalOpen] =
    useState(false);

  const onClickProceedWithPayment = () => setPaymentDetailsState(true);

  const onClickProceedWithPayment1 = () => setPaymentDetailsState1(true);

  const onClickApplePay = () => {};

  return (
    <>
      {/* Header */}
      <div
        className={classes.header}
        style={{
          borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          background: Colors.white,
        }}
      >
        <div className={[classes.content].join(" ")}>
          <ReactSVG
            src={CancelIconBlack}
            className={classes.cancelIcon}
            onClick={() => {
              setPaymentDetailsState
                ? setPaymentDetailsState(false)
                : history.goBack();
            }}
          />
          <p
            style={{
              ...Fonts.b3,
              color: Colors.neutralShadesOfNero,
            }}
            className={[classes.pl16].join(" ")}
          >
            Confirm and Pay
          </p>
        </div>
      </div>
      {/* Content */}
      <div className={`container-fluid ${classes.container}`}>
        {paymentDetailsState === false ? (
          <>
            <MobileConfirmBookingLessonCard
              setIsCancellationModalOpen={setIsCancellationModalOpen}
              setIsRequirementsModalOpen={setIsRequirementsModalOpen}
              setIsBookingRequestedModalOpen={setIsBookingRequestedModalOpen}
              setIsErrorOccurenceModalOpen={setIsErrorOccurenceModalOpen}
            />
            <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
              What's Provided
            </h5>
            {/* <p
            style={{
              ...Fonts.h1,
              color: Colors.neutralShadesOfNero,
              fontSize: 19,
              fontWeight: "bold",
              lineHeight: "34px",
            }}
          >
            <b>What's Provided</b>
          </p> */}
            <p
              style={{
                ...Fonts.p,
                color: Colors.neutralShadesOfNero,
                fontSize: 16,
                lineHeight: "24px",
                marginBottom: 30,
              }}
            >
              There are things you should have when coming to a lesson. See
              what's provided by your coach and be sure to bring everything
              else.{" "}
              <b
                style={{
                  ...Fonts.p1,
                  color: Colors.mainBlue,
                  fontSize: 19,
                  fontWeight: "bold",
                  lineHeight: "24px",
                  fontSize: 16,
                }}
              >
                Learn More
              </b>
            </p>

            <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
              Who are you booking the lesson for?
            </h5>

            <div className={classes.flex}>
              <Radio
                value={radioState}
                setValue={setRadioState}
                label={"I’m booking it for myself"}
              />

              <Radio
                value={radioState}
                setValue={setRadioState}
                label={"I’m booking it for someone else"}
              />
            </div>
            {radioState === "I’m booking it for myself" ? (
              <>
                <TextArea label={"Add notes (optional)"} />
              </>
            ) : (
              <>
                <form
                  className="col-md-12"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className={`${classes.inputMb32} ${classes.inputMt32}`}>
                    <Input
                      type={"text"}
                      label={"Full Name"}
                      placeholder={"Jonathan Moriarty"}
                      state={fullName}
                      setter={setFullName}
                    />
                  </div>

                  <div className={`${classes.inputMb32} ${classes.inputMt32}`}>
                    <Input
                      type={"text"}
                      label={"Date of Birth"}
                      placeholder={"02/ 06/ 2022"}
                      state={dob}
                      setter={setDob}
                    />
                  </div>

                  <div className={`${classes.inputMb32} ${classes.inputMt32}`}>
                    <Input
                      type={"number"}
                      label={"Phone number"}
                      placeholder={"+1 (321) - 453 - 3325"}
                      state={phoneNumber}
                      setter={setPhoneNumber}
                    />
                  </div>

                  <div className={`${classes.inputMb32} ${classes.inputMt32}`}>
                    <TextArea
                      label={"Add notes (optional)"}
                      placeholder={
                        "Greet your coach. What do you want to accomplish?"
                      }
                    />
                  </div>
                </form>
              </>
            )}
            <div className={classes.mt32}>
              <Button
                onClick={onClickProceedWithPayment}
                primary={false}
                disabled={false}
                label={"Proceed with payment"}
                size={"Large"}
                customStyle={{
                  padding: "12px 32px",
                  ...Fonts.b1,
                  // marginBottom: "12px",
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div
              className={classes.lesson_price_div}
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <p style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                Lesson Price
              </p>
              <p style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                $85
              </p>
            </div>
            <div>
              {!paymentDetailsState1 ? (
                <>
                  <h5
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                  >
                    Payment details
                  </h5>
                  <p>Payment will be charged after the lesson.</p>
                  <Row>
                    <Col
                      md={12}
                      sm={12}
                      xs={12}
                      className={`${classes.inputMt32}`}
                    >
                      <Input
                        type={"text"}
                        placeholder={"0000 0000 0000 0000"}
                        label={"Card number"}
                        state={cardNumber}
                        setter={setCardNumber}
                      />
                    </Col>
                    <Col
                      md={12}
                      sm={12}
                      xs={12}
                      className={`${classes.inputMb32} ${classes.inputMt32}`}
                    >
                      <Input
                        type={"text"}
                        placeholder={"Jonathan Moriarty"}
                        label={"Cardholder’s name"}
                        state={cardholderName}
                        setter={setCardholderName}
                      />
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <Input
                        type={"text"}
                        placeholder={"02/ 2023"}
                        label={"Expiration Date"}
                        state={expiryDate}
                        setter={setExpiryDate}
                      />
                    </Col>
                    <Col
                      md={12}
                      sm={12}
                      xs={12}
                      className={`${classes.inputMb32} ${classes.inputMt32}`}
                    >
                      <Input
                        type={"password"}
                        placeholder={"123"}
                        label={"CVC"}
                        state={cvc}
                        setter={setCvc}
                      />
                    </Col>
                  </Row>
                  <Row className={`row ${classes.rowMB}`}>
                    <Col md={12} sm={12} xs={12}>
                      <Checkbox
                        value={checkBoxState}
                        setValue={setCheckBoxState}
                        label={
                          "Save payment information to my account for future purchases"
                        }
                      />
                    </Col>
                  </Row>
                  <p
                    style={{
                      ...Fonts.h1,
                      color: Colors.neutralShadesOfNero,
                      fontSize: 19,
                      fontWeight: "bold",
                      lineHeight: "44px",
                      marginTop: 40,
                    }}
                  >
                    <b>Cancellation Policy</b>
                  </p>
                  <p
                    style={{
                      ...Fonts.p,
                      color: Colors.neutralShadesOfNero,
                      fontSize: 16,
                      lineHeight: "24px",
                    }}
                  >
                    Free cancellation up to 24 hours before lesson starts. If
                    you cancel a class less than 24 hours before the start of
                    the lesson, the booking will not be refunded{" "}
                    <b
                      style={{
                        ...Fonts.p1,
                        color: Colors.mainBlue,
                        fontSize: 19,
                        fontWeight: "bold",
                        lineHeight: "24px",
                        fontSize: 16,
                      }}
                    >
                      Learn More
                    </b>
                  </p>

                  <p style={{ marginBlock: 20 }}>
                    By clicking the button below I accept Lytesnap’s terms of
                    use
                  </p>
                  <div className={classes.mt32}>
                    <Button
                      onClick={onClickProceedWithPayment1}
                      primary={true}
                      // disabled={disabled}
                      label={"Proceed with payment"}
                      size={"Large"}
                      customStyle={{
                        padding: "12px 32px",
                        ...Fonts.b1,
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <h5
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                  >
                    Payment details
                  </h5>
                  <p>Payment will be charged after the lesson.</p>

                  <div className={classes.grid}>
                    <Radio
                      value={paymentDetailsRadioState}
                      setValue={setPaymentDetailsRadioState}
                      label={"Visa •••• 3679 (expires 12/24)"}
                    />

                    <Radio
                      value={paymentDetailsRadioState}
                      setValue={setPaymentDetailsRadioState}
                      label={"MasterCard •••• 2193 (expires 03/22)"}
                    />
                    <Radio
                      value={paymentDetailsRadioState}
                      setValue={setPaymentDetailsRadioState}
                      label={"New payment method"}
                    />
                  </div>

                  {paymentDetailsRadioState === "New payment method" && (
                    <form
                      className="col-md-12"
                      style={{
                        position: "relative",
                      }}
                    >
                      <Row>
                        <Col
                          md={12}
                          sm={12}
                          xs={12}
                          className={`${classes.inputMt32}`}
                        >
                          <Input
                            type={"text"}
                            placeholder={"0000 0000 0000 0000"}
                            label={"Card number"}
                            state={cardNumber1}
                            setter={setCardNumber1}
                          />
                        </Col>
                        <Col
                          md={12}
                          sm={12}
                          xs={12}
                          className={`${classes.inputMb32} ${classes.inputMt32}`}
                        >
                          <Input
                            type={"text"}
                            placeholder={"Jonathan Moriarty"}
                            label={"Cardholder’s name"}
                            state={cardholderName1}
                            setter={setCardholderName1}
                          />
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                          <Input
                            type={"text"}
                            placeholder={"02/ 2023"}
                            label={"Expiration Date"}
                            state={expiryDate1}
                            setter={setExpiryDate1}
                          />
                        </Col>
                        <Col
                          md={12}
                          sm={12}
                          xs={12}
                          className={`${classes.inputMb32} ${classes.inputMt32}`}
                        >
                          <Input
                            type={"password"}
                            placeholder={"123"}
                            label={"CVC"}
                            state={cvc1}
                            setter={setCvc1}
                          />
                        </Col>
                      </Row>
                    </form>
                  )}

                  <p
                    style={{
                      ...Fonts.h1,
                      color: Colors.neutralShadesOfNero,
                      fontSize: 19,
                      fontWeight: "bold",
                      lineHeight: "44px",
                      marginTop: 40,
                    }}
                  >
                    <b>Cancellation Policy</b>
                  </p>
                  <p
                    style={{
                      ...Fonts.p,
                      color: Colors.neutralShadesOfNero,
                      fontSize: 16,
                      lineHeight: "24px",
                    }}
                  >
                    Free cancellation up to 24 hours before lesson starts. If
                    you cancel a class less than 24 hours before the start of
                    the lesson, the booking will not be refunded{" "}
                    <b
                      style={{
                        ...Fonts.p1,
                        color: Colors.mainBlue,
                        fontSize: 19,
                        fontWeight: "bold",
                        lineHeight: "24px",
                        fontSize: 16,
                      }}
                    >
                      Learn More
                    </b>
                  </p>

                  <p style={{ marginBlock: 20 }}>
                    By clicking the button below I accept Lytesnap’s terms of
                    use
                  </p>

                  <Button
                    onClick={onClickApplePay}
                    size={"Large"}
                    primary={false}
                    customStyle={{
                      padding: "18px 32px",
                      ...Fonts.b2,
                    }}
                    label={
                      <span
                        style={{
                          ...Fonts.h8,
                        }}
                        className={classes.btn1Label}
                      >
                        Pay using{" "}
                        <ReactSVG
                          className={classes.apple_icon}
                          src={ApplePayBlack}
                          beforeInjection={(svg) => {
                            svg.classList.add(classes.applePayIcon);
                          }}
                        />
                        Pay
                      </span>
                    }
                  />
                  <div className={classes.mt32}>
                    <Button
                      onClick={onClickProceedWithPayment}
                      primary={true}
                      // disabled={disabled}
                      label={"Proceed with payment"}
                      size={"Large"}
                      customStyle={{
                        padding: "12px 32px",
                        ...Fonts.b1,
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
      <MobileFooter />
      <CancellationPolicyModal
        show={isCancellationModalOpen}
        setShow={setIsCancellationModalOpen}
      />
      {/* <RequirementsModal
        show={isRequirementsModalOpen}
        setShow={setIsRequirementsModalOpen}
      /> */}
      {/* <BookingRequestedModal
        show={isBookingRequestedModalOpen}
        setShow={setIsBookingRequestedModalOpen}
      /> */}
      {/* <ErrorOccurModal
        show={isErrorOccurenceModalOpen}
        setShow={setIsErrorOccurenceModalOpen}
      /> */}
    </>
  );
};

export default BookingLesson;
